import Axios from "../../../_services/caller.service";
import React, { useContext, useState } from "react";

import { handleValidation } from "../../../utils/formValidation";
import Error from "../../UiComponents/error/Error";
import BtnForms from "../../UiComponents/forms/BtnForms";
import ContainerForm from "../../UiComponents/forms/ContainerForm";

import InputPassword from "../../UiComponents/forms/InputPassword";
import RulesPassword from "../../UiComponents/forms/RulesPassword";
import Loader from "../../UiComponents/loader/Loader";
import Success from "../../UiComponents/sucess/Success";
import NavContext from "../../../context/NavContext";

const ChangePassword = () => {
  const [password, setPassword] = useState("");
  const [password2, setPassword2] = useState("");
  const [oldPassword, setOldPassword] = useState("");

  const { ownerProfile, ownerId } = useContext(NavContext);

  const [errorMessage, setErrorMessage] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [error, setEror] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errorValidation, setErrorValidation] = useState(null);
  const [loading, setLoading] = useState(false);

  const submitChangePassword = async (e) => {
    e.preventDefault();

    // ✅ CHANGEMENT: on active le loader au début
    setLoading(true);

    // ✅ CHANGEMENT: on ne fait plus de POST /login pour "tester" l'ancien mdp
    // Le backend changePassword doit vérifier currentPassword lui-même (c’est la bonne logique)
    try {
      const res = await Axios.put("/changePassword", {
        data: {
          // ✅ CHANGEMENT: on n’envoie plus ID (le backend prend l’id depuis le JWT de session)
          currentPassword: oldPassword, // ✅ CHANGEMENT: ancien mot de passe envoyé
          password,
          password2,
        },
      });

      setLoading(false);

      // Ton backend renvoie { error: false/true, message: ... }
      if (res.data?.error) {
        setEror(true);
        setErrorMessage(res.data.message || "Erreur lors du changement de mot de passe");
        setTimeout(() => setEror(false), 1500);
        return;
      }

      setSuccess(true);
      setSuccessMessage(res.data.message || "Mot de passe modifié");
      setTimeout(() => setSuccess(false), 1500);

      // ✅ CHANGEMENT: on peut reset les champs après succès
      setOldPassword("");
      setPassword("");
      setPassword2("");
      setErrorValidation(null);
    } catch (err) {
      setLoading(false);

      // ✅ CHANGEMENT: gestion d’erreur propre (et correction du bug console.log(error) qui n'existait pas)
      setEror(true);
      setErrorMessage("Une erreur est survenue");
      setTimeout(() => setEror(false), 1500);

      console.log(err);
    }
  };

  return (
    <div>
      <ContainerForm
        onSubmit={submitChangePassword}
        modal={false}
        children={
          <>
            <InputPassword
              onChange={(e) => setOldPassword(e.target.value.trim())}
              placeholder="Ancien mot de passe"
              value={oldPassword}
            />
            <InputPassword
              onChange={(e) => setPassword(e.target.value.trim())}
              placeholder="Nouveau mot de passe"
              onKeyUp={(e) => setErrorValidation(handleValidation(e))}
              value={password}
            />
            <InputPassword
              onChange={(e) => setPassword2(e.target.value.trim())}
              placeholder="Confirmer le nouveau mot de passe"
              value={password2}
            />

            {errorValidation !== "" && errorValidation !== null && (
              <Error error={errorValidation} />
            )}
            {errorValidation === "" && <Success success={"mot de passe valide"} />}

            <BtnForms text="Changer mon mot de passe" />

            {success && <Success success={successMessage} />}
            {error && <Error error={errorMessage} />}
            {loading && <Loader />}

            <RulesPassword />
          </>
        }
      />
    </div>
  );
};

export default ChangePassword;
